<template>
  <div>
    <DialogIncludeCloseIcon
      :dialogTitle="$t('table_pcaf_vehicle_loan.label_vehicle_type')"
      :dialog="dialog"
      @close="close"
      :hasAction="true"
      :cancelText="$t('tkm_pattern_table.label_popup_search_cancel')"
      :confirmText="$t('table_pcaf_vehicle_loan.label_popup_search_submit')"
      @submit="submit"
      :disabled="disableSubmitButton"
    >
      <div class="search-wrapper-popup">
        <div class="search-input">
          <label class="search-label">{{ $t('table_pcaf_vehicle_loan.label_producer_name') }}</label>
          <div class="search-input-icon">
            <infinite-scroll-include-search
              dropdownElementId="select-producer_name"
              inputFieldElementId="input-producer_name"
              searchInput="select-producer_name"
              tooltipColumn="tooltipsearch"
              :items="listProducerName"
              :model="searchData.producerName"
              item-text="producer_name"
              item-value="producer_name"
              :isIconSearch="true"
              :isShowDropDownOnSearching="true"
              @focus="getCurrentData(searchData.producerName, 'producerName')"
              @updateMasterDb="onSelectSearchProducerName"
              @blur="handleBlurInput(searchData.producerName, 'producerName')"
            />
          </div>
        </div>
        <div class="search-input">
          <label class="search-label">{{ $t('table_pcaf_vehicle_loan.label_model') }}</label>
          <div class="search-input-icon">
            <infinite-scroll-include-search
              dropdownElementId="select-car_name"
              inputFieldElementId="input-car_name"
              searchInput="select-car_name"
              tooltipColumn="tooltipsearch"
              :items="listCarName"
              :model="searchData.carName"
              item-text="car_name"
              item-value="car_name"
              :isIconSearch="true"
              :isShowDropDownOnSearching="true"
              @focus="getCurrentData(searchData.carName, 'carName')"
              @updateMasterDb="onSelectSearchCarName"
              @blur="handleBlurInput(searchData.carName, 'carName')"
            />
          </div>
        </div>
        <div class="search-input">
          <label class="search-label">{{ $t('table_pcaf_vehicle_loan.label_type_car_loan') }}</label>
          <div class="search-input-icon">
            <infinite-scroll-include-search
              dropdownElementId="select-model"
              inputFieldElementId="input-model"
              searchInput="select-model"
              tooltipColumn="tooltipsearch"
              :items="listCarModel"
              :model="searchData.model"
              item-text="model"
              item-value="model"
              :isIconSearch="true"
              :isShowDropDownOnSearching="true"
              @focus="getCurrentData(searchData.model, 'model')"
              @updateMasterDb="onSelectSearchModel"
              @blur="handleBlurInput(searchData.model, 'model')"
            />
          </div>
        </div>
      </div>
      <div class="external-sources-table tkm-popup-table">
        <data-table
          :init-grid="initGrid"
          :data-source="fuelConsumptionGrid"
          :grid-columns="fuelConsumptionColumns"
          :allowAddNew="false"
          :isShowToolbar="false"
          :rowFocus="1"
          :showFocus="false"
          :tableName="'searchExternalSource'"
          :labelEmpty="messageLabelEmpty"
          :isEmptySource="isEmptySource"
          :isRemoveIndex="true"
          :headersVisibility="headersVisibility"
          :currentPage="currentPage"
          :currentPageSize="currentPageSize"
        />
      </div>
    </DialogIncludeCloseIcon>
  </div>
</template>
<script>
import DataTable from '@/components/category/data-table';
import DialogIncludeCloseIcon from '@/components/dialogs/base/DialogIncludeCloseIcon';
import InfiniteScrollIncludeSearch from '@/components/pulldown/InfiniteScrollIncludeSearch';

import { mapActions } from 'vuex';
import { CollectionView } from '@mescius/wijmo';
import { setMinMaxSizeColumns } from '@/utils/calcTextWidth';
import { getCarLoanModel } from '@/api/pcaf';
import { BLANK_ID } from '@/constants/registerData';
import { VEHICLE_TYPE } from '@/constants/tkm-method';
import { DEFAULT_PAGING } from '@/constants/basic-unit.js';
import { convertFullWidthToHalfWidthIncludeSpecialCharacter } from '@/utils/convertHalfWidth'
import * as wjcCore from '@mescius/wijmo';

export default {
  name: 'SearchModelCarLoanPopup',
  components: { DataTable, DialogIncludeCloseIcon, InfiniteScrollIncludeSearch },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedModel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      flexGrid: null,
      fuelConsumptionGrid: null,
      fuelConsumptionColumns: [],
      data: [],
      carLoanModelData: [],
      vehicleType: VEHICLE_TYPE,
      vehicleModel: 1,
      selectedItem: null,
      isEmptySource: false,
      reRenderPulldown: 0,
      searchData: {
        producerName: null,
        carName: null,
        model: null,
      },
      oldData: {
        producerName: '',
        carName: '',
        model: '',
      },
      reRenderPaging: 0,
      currentPage: 1,
      currentPageSize: DEFAULT_PAGING.pageSize,
      firstTime: true,
      timerId: null,
      carModelIdentifierTooltip: null,
      carLoanModelDataOrigin: [],
      listCarName: [],
      listProducerName: [],
      listCarModel: [],
      blurTimeoutId: null,
      isSelectingFromDropdown: false,
    };
  },
  async mounted() {
    this.carModelIdentifierTooltip = new wjcCore.Tooltip({ position: wjcCore.PopupPosition.Below });
    this.carModelIdentifierTooltip.showDelay = 100;
    await this.getModelCarLoanData();
    this.initialView();
  },
  created() {},
  computed: {
    getDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('update:dialog', value);
      },
    },
    messageLabelEmpty() {
      return '';
    },
    disableSubmitButton() {
      return this.fuelConsumptionGrid?.items?.length === 0 || !this.selectedItem;
    },
    headersVisibility() {
      return 'Column';
    },
  },
  watch: {},
  methods: {
    ...mapActions('commonApp', ['actionUpdateIsLoadingPopUp']),
    async getModelCarLoanData() {
      try {
        this.carLoanModelData = [];
        this.actionUpdateIsLoadingPopUp(true);
        const payload = {}
        if (this.searchData.producerName) payload.producer_name = this.searchData?.producerName;
        if (this.searchData.carName) payload.car_name = this.searchData?.carName;
        if (this.searchData.model) payload.model = this.searchData?.model;

        const { data } = await getCarLoanModel(payload)
        this.carLoanModelData = data;
        if (this.firstTime) {
          this.carLoanModelDataOrigin = data;
          this.listCarModel = this.createModelList(data);
          this.listCarName = this.createCarNameList(data);
          this.listProducerName = this.createProducerNameList(data);
          this.firstTime = false;
        }
        this.fuelConsumptionGrid = new CollectionView([...this.carLoanModelData]);
        this.isEmptySource = this.fuelConsumptionGrid?.items?.length <= 0;
        this.flexGrid.columnGroups = this.initGridColumn();
        setMinMaxSizeColumns(this.flexGrid, this.carLoanModelData);
        this.fuelConsumptionGrid.currentItem = null;
        this.reRenderPaging++; 
      } catch (error) {
        this.actionUpdateIsLoadingPopUp(false);
        console.error(error);
      } finally {
        this.actionUpdateIsLoadingPopUp(false);
      }
    },
    close() {
      this.$emit('close');
    },
    submit() {
      this.$emit('close');
      this.$emit('submit', this.selectedItem);
    },
    initGridColumn() {
      return [
        {
          header: this.$t('tkm_pattern_table.table_select_radio_search_tkm'),
          binding: 'select_car_loan',
          maxWidth: 50,
          minWidth: 50,
          allowSorting: false,
          isReadOnly: false,
          isRequired: false,
          dataType: 'Boolean',
          cssClassAll: 'single-row hide-filter justify-center',
        },
        {
          header: this.$t('table_pcaf_vehicle_loan.label_type_car_loan'),
          binding: 'model',
          minWidth: 130,
          maxWidth: 980,
          allowSorting: false,
          isRequired: false,
          wordWrap: true,
          multiLine: true,
          cssClassAll: 'single-row hide-filter justify-center',
        },
        {
          header: this.$t('table_pcaf_vehicle_loan.label_classification_number'),
          binding: 'classification_number',
          minWidth: 609,
          maxWidth: 980,
          allowSorting: false,
          isRequired: false,
          wordWrap: true,
          cssClassAll: 'single-row hide-filter justify-center',
        },
        {
          header: this.$t('table_pcaf_vehicle_loan.label_fuel_cost_unit'),
          binding: 'fuel_efficiency',
          minWidth: 300,
          width: '*',
          allowSorting: false,
          isRequired: false,
          wordWrap: true,
          cssClassAll: 'single-row hide-filter justify-center',
          align: 'right',
        }
      ];
    },
    onSelectItem(item) {
      this.selectedItem = item;
    },
    initGrid(grid) {
      this.flexGrid = grid;

      grid.scrollPositionChanged.addHandler((s) => {});

      if (this.flexGrid) {
        this.flexGrid.columnGroups = this.initGridColumn();
      }

      grid.itemsSourceChanged.addHandler(() => {
        this.$nextTick(() => {
          if (this.timerId) clearTimeout(this.timerId);
          this.timerId = setTimeout(() => {
            const rowIndex = grid.rows.findIndex((r) => r.dataItem?.id === this.selectedModel?.id);
            const row = grid.rows[rowIndex];

            if (row) {
              const rc = grid.cells.getCellBoundingRect(rowIndex, 0, true);
              const headerHeight = grid.columnHeaders.hostElement.clientHeight;
              const viewHeight = grid.hostElement.clientHeight - headerHeight;
              const scrollY = viewHeight / 2 - (rc.top + rc.height);

              grid.scrollPosition = new wjcCore.Point(grid.scrollPosition.x, scrollY);
            }
          }, 10);
        });
      });

      grid.beginningEdit.addHandler((s, e) => {
        const column = s.columns[e.col];
        if (column.binding === 'select_car_loan') {
          e.cancel = false;
        } else e.cancel = true;
      });
      grid.formatItem.addHandler((s, e) => {
        const colBinding = e.panel.columns[e.col].binding;
        if (e.panel === s.cells && colBinding === 'select_car_loan') {
          const rowData = s.rows[e.row].dataItem;
          const radioButton = document.createElement('input');
          radioButton.type = 'radio';
          radioButton.name = 'select_car_loan';
          radioButton.className = 'custom-radio-table';
          radioButton.value = rowData.id;
          if (!Object.keys(this.selectedModel).length && e.row === 0) {
            // selected the first row when the model has not been selected
            radioButton.ariaChecked = true;
            this.onSelectItem(rowData);
          } else if (this.selectedModel && rowData.id === this.selectedModel.id) {
            radioButton.ariaChecked = true;
            this.onSelectItem(this.selectedModel);
          } else {
            radioButton.ariaChecked = false;
          }
          radioButton.addEventListener('change', () => {
            this.onSelectItem(rowData);
            Array.from(document.querySelectorAll('input[name="select_car_loan"]')).forEach((radio) => {
              const isChecked = radioButton.getAttribute('value') === radio.getAttribute('value');
              radio.setAttribute('aria-checked', isChecked ? 'true' : 'false');
            });
          });
          e.cell.innerHTML = '';
          e.cell.appendChild(radioButton);
        }
      });
      grid.hostElement?.addEventListener(
        'mouseover',
        (event) => {
          this.tooltipOnCellMouseOver(event, grid);
        }
      );

      grid.hostElement.addEventListener('mouseout', (e) => {
        this.carModelIdentifierTooltip.hide();
      });
    },
    initialView() {
      this.fuelConsumptionColumns = this.initGridColumn();
      if (this.fuelConsumptionGrid) {
        this.data = this.fuelConsumptionGrid.items.filter((item) => item.id && item.id !== BLANK_ID);
        this.fuelConsumptionGrid.currentItem = null;
      }
      if (this.flexGrid) {
        this.flexGrid.columnGroups = this.initGridColumn();
        setMinMaxSizeColumns(this.flexGrid, this.carLoanModelData);
      }
    },
    getCurrentData(value, key) {
      this.oldData[key] = value ? value : ''
    },
    handleBlurInput(value, key) {
      if (this.blurTimeoutId) {
        clearTimeout(this.blurTimeoutId);
        this.blurTimeoutId = null;
      }

      this.blurTimeoutId = setTimeout(() => {
        if (!this.isSelectingFromDropdown && this.oldData[key] !== value) {
          this.getModelCarLoanData();
        }
        this.isSelectingFromDropdown = false;
        this.blurTimeoutId = null;
      }, 150);
    },
    createProducerNameList(carModelList) {
      const producerNameMap = new Map()
      carModelList.forEach(({ producer_name }) => {
        if (producer_name && !producerNameMap.has(producer_name)) {
          producerNameMap.set(producer_name, {
            producer_name,
            value: producer_name,
            name: producer_name,
          })
        }
      })
      return Array.from(producerNameMap.values())
    },
    createCarNameList(carModelList) {
      const carNameMap = new Map()
      carModelList.forEach(({ car_name }) => {
        if (car_name && !carNameMap.has(car_name)) {
          carNameMap.set(car_name, {
            car_name,
            value: car_name,
            name: car_name,
          })
        }
      })
      return Array.from(carNameMap.values())
    },
    createModelList(carModelList) {
      const producerNameMap = new Map()
      carModelList.forEach(({ model }) => {
        if (model && !producerNameMap.has(model)) {
          producerNameMap.set(model, {
            model,
            value: model,
            name: model,
          })
        }
      })
      return Array.from(producerNameMap.values())
    },
    onSelectSearchProducerName(value) {
      this.isSelectingFromDropdown = true;
      this.$set(this.searchData, 'producerName', value)
      this.handelFilterData();
      setTimeout(() => {
        this.isSelectingFromDropdown = false;
      }, 0);
    },
    onSelectSearchCarName(value) {
      this.isSelectingFromDropdown = true;
      this.$set(this.searchData, 'carName', value)
      this.handelFilterData();
      setTimeout(() => {
        this.isSelectingFromDropdown = false;
      }, 0);
    },
    onSelectSearchModel(value) {
      this.isSelectingFromDropdown = true;
      this.$set(this.searchData, 'model', value)
      this.handelFilterData();
      setTimeout(() => {
        this.isSelectingFromDropdown = false;
      }, 0);
    },
    tooltipOnCellMouseOver(e, grid) {
      const ht = grid.hitTest(e);
      const col = grid.columns[ht.col];
      const binding = col?.binding;
      const cell = e.target;
      
      if (binding === 'classification_number' && cell.scrollWidth > cell.clientWidth + 1) {
        this.carModelIdentifierTooltip.show(cell, `<div class='wj-cell-text-ellipsis'>${cell?.textContent}</div>`)
        
      } else {
        this.carModelIdentifierTooltip.hide();
      }
    },
    handelFilterData() {
      // Reset carLoanModelData
      this.carLoanModelData = this.carLoanModelDataOrigin;
      const newList =  this.carLoanModelData.filter(item => {
        let matchCarName = true, matchModel = true, matchProducer = true;
        if (this.searchData.carName && item.car_name) {
          const searchTerms = convertFullWidthToHalfWidthIncludeSpecialCharacter(this.searchData.carName)
            .toLowerCase()
            .split(',')
            .map(s => s.trim())
            .filter(s => s);
          const normalizedText = convertFullWidthToHalfWidthIncludeSpecialCharacter(item.car_name).toLowerCase();
          matchCarName = searchTerms.some(term => normalizedText.includes(term));
        }
        if (this.searchData.model && item.model) {
          const searchTerms = convertFullWidthToHalfWidthIncludeSpecialCharacter(this.searchData.model)
            .toLowerCase()
            .split(',')
            .map(s => s.trim())
            .filter(s => s);
          const normalizedText = convertFullWidthToHalfWidthIncludeSpecialCharacter(item.model).toLowerCase();
          matchModel = searchTerms.some(term => normalizedText.includes(term));
        }
        if (this.searchData.producerName && item.producer_name) {
          const searchTerms = convertFullWidthToHalfWidthIncludeSpecialCharacter(this.searchData.producerName)
            .toLowerCase()
            .split(',')
            .map(s => s.trim())
            .filter(s => s);
          const normalizedText = convertFullWidthToHalfWidthIncludeSpecialCharacter(item.producer_name).toLowerCase();
          matchProducer = searchTerms.some(term => normalizedText.includes(term));
        }
        return matchCarName && matchModel && matchProducer;
      });
      this.listCarName = this.createCarNameList(newList)
      this.listCarModel = this.createModelList(newList)
      this.listProducerName = this.createProducerNameList(newList)
    }
  },
  beforeDestroy() {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
    if (this.blurTimeoutId) {
      clearTimeout(this.blurTimeoutId);
      this.blurTimeoutId = null;
    }
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/components/popup/index.scss';
  .search-wrapper-popup {
    width: 30%;
    padding-bottom: 49.5px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    .search-input {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .search-label {
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0.42px;
      }

      .search-input-icon{
        position: relative;
        .search-icon{
          position: absolute;
          inset: 0 0 0 auto;
          padding: 8px 9px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      ::v-deep(.v-input__control) {
        .v-input__slot {
          box-shadow: none !important;
        }
      }
    }
  }
</style>